<template>
  <va-create-layout>
    <news-form :title="title" :item="item"></news-form>
  </va-create-layout>
</template>

<script>
export default {
  props: ["title", "item"],
};
</script>
